
import {
  List,
  Datagrid,
  TextField,
  Filter,
  TextInput,
} from 'react-admin';

import CustomActions from '../../../components/CustomActions';
import { ListPagination } from '../../../utils';

const ProjectFilter = props => (
  <Filter {...props}>
    <TextInput label="Nome" source="name" alwaysOn />
    <TextInput label="Laboratório" source="lab.name" />
    <TextInput label="Grupo" source="group.name" />
  </Filter>
);


const ProjectList = (props) => (
  <List
    basePath="/projects"
    perPage={25}
    title="Lista de Projetos"
    hasCreate={true}
    actions={<CustomActions />}
    sort={{ field: "createdAt", order: "DESC" }}
    filters={<ProjectFilter />}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField sortable={false} label="Laboratório" source="lab.name" />
      <TextField sortable={false} label="Grupo" source="lab.group.name" />
    </Datagrid>
  </List>
);

export default ProjectList;
